import React, { useState, useRef, useEffect } from "react";
import { API_BASE_URL } from "../../config";
import axios from "axios";
import useIsMountedRef from "../../utils/mountedRef";
import { useSnackbar } from "notistack";
import { ToolTipSearch } from "../../components/selects/tooltip_search";
import Fuse from "fuse.js";
import ReactGA from "react-ga4";
import "./lateralMenu.css";
import CollapseMenu from "./collapseMenu";
import { ToolTipPerso } from "../../components/selects/tooltip_perso";
import Tableau from "../../assets/docs/tableau_5.pdf";
import Memo from "../../assets/docs/Memo_d_utilisation.pdf";
import Mail from "../../components/mail/mail";
import Breadcrumb from "../breadcrumb/breadcrumb";

const LateralMenu = ({ setActiveTab }) => {
  const [width, setWidth] = useState(300);
  const [isResizing, setIsResizing] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isLateralMenuCollapsed, setIsLateralMenuCollapsed] = useState(false);
  const minSidebarWidth = 200;
  const collapsedWidth = 70;
  const sidebarRef = useRef(null);
  const [categoriesOther, setCategoriesOther] = useState([]);
  const others = [42, 103, 104, 105, 106];
  const dmtg = [55, 56, 109, 110];
  const [categories, setCategories] = useState([]);
  const [allFavoris, setAllFavoris] = useState(localStorage.getItem("favoris"));
  const [emolActes, setEmolActes] = useState([]);
  const [fiscaActes, setFiscaActes] = useState([]);
  const [droitsFixesActes, setDroitsFixesActes] = useState([]);
  const [open, setOpen] = useState(false);

  const navigateToPage = (pageUrl) => {
    window.location.href = pageUrl;
  };

  const handleChange = async (setter, value) => {
    setter(value);
  };

  function disconnect() {
    localStorage.removeItem("user");
    localStorage.removeItem("remarque");
    localStorage.removeItem("currentEmol");
    localStorage.removeItem("chart");
    window.location = "/";
  }

  useEffect(() => {
    const handleMouseMove = (event) => {
      if (isResizing && !isLateralMenuCollapsed) {
        const newWidth = event.clientX - sidebarRef.current.getBoundingClientRect().left;

        if (newWidth <= minSidebarWidth) {
          setIsLateralMenuCollapsed(true);
          setWidth(collapsedWidth);
        } else {
          setWidth(newWidth);
        }
      }
    };

    const handleMouseUp = () => {
      setIsResizing(false);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isResizing, isLateralMenuCollapsed]);

  const toggleCollapse = () => {
    setIsLateralMenuCollapsed(!isLateralMenuCollapsed);
    if (!isLateralMenuCollapsed) {
      setWidth(collapsedWidth);
    } else {
      setWidth(300);
    }
  };

  const [hoveredItem, setHoveredItem] = useState(null);

  const isMountedRef = useIsMountedRef();

  let simulateurAdded = false;
  let ficheAdded = false;

  let test = window.location.href.split("/");

  test.reverse();
  test.pop();
  test.pop();
  test.pop();
  test.reverse();

  let latest = [];
  for (let i = 0; i < test.length; i++) {
    if (i % 1 === 0 && i !== 0 && isNumeric(test[i])) {
      latest[latest.length - 1] += " " + test[i];
    } else latest.push(test[i]);
    //console.log(latest)
  }

  for (let i = 0; i < test.length; i++) {
    if (isNumeric(test[i]) === true) {
      //console.log("number")
    }
  }

  function isNumeric(str) {
    if (typeof str != "string") return false;
    return !isNaN(str) && !isNaN(parseFloat(str));
  }

  const [simulateurs, setSimulateurs] = useState([]);
  const [simulateursProposal, setSimulateursProposal] = useState([]);
  const [fiches, setFiches] = useState([]);
  const [fichesProposal, setFichesProposal] = useState([]);
  const [expertOpinions, setExpertOpinions] = useState([]);
  const [expertOpinionsProposal, setExpertOpinionsProposal] = useState([]);
  const [emolActeProposal, setEmolActeProposal] = useState([]);
  const [fiscaActeProposal, setFiscaActeProposal] = useState([]);
  const [droitsFixesActeProposal, setDroitsFixesActeProposal] = useState([]);
  const [searchValueInput, setSearchValueInput] = useState("");
  const ctnSearchBarRef = useRef(null);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    var simulateurs = {
      method: "get",
      url: `${API_BASE_URL}/simulateurs`,
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("user"))?.jwt,
      },
    };
    axios(simulateurs)
      .then((response) => {
        if (response.status === 200 && response.data != null) {
          if (isMountedRef.current) {
            setSimulateurs(response.data);
          }
        } else {
          enqueueSnackbar("Une erreur est survenue", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 401 && error.response.data != null) {
          if (error.response.data.error == "Other_user_connected") {
            localStorage.removeItem("user");
            localStorage.setItem("other_user_connected", "other_user_connected");
            window.location.href = "/login";
          }
        }
      });

    setFiches([
      // Générales
      {
        href: "/static/media/Les_debours.4626eecbbde6f30bc2a3.pdf",
        name: "Les débours",
      },
      {
        href: "/static/media/Specificites_alsace_moselle.ea9faa0adc84c9e8552c.pdf",
        name: "Les spécificités des frais d'actes notariés en Alsace-Moselle",
      },
      {
        href: "/static/media/Les_tarifs_BALO.2f2a46f737534850c542.pdf",
        name: "Les tarifs BALO",
      },
      {
        href: "/static/media/Les_tarifs_BODACC.6b1d2ebeafbcd8c65a7a.pdf",
        name: "Les tarifs BODACC",
      },
      // Immo
      {
        href: "/static/media/Fiscalite_SAFER.88917b4b994609e03fd8.pdf",
        name: "La fiscalité des SAFER",
      },
      {
        href: "/static/media/Check_list_plus_values.3e5de256db288cab1a8e.pdf",
        name: "Check-list sur les plus-values",
      },
      {
        href: "/static/media/Ce_qu_il_ne_faut_pas_oublier_lors_d_une_vente_(check-list).6a6923913d999751a7a2.pdf",
        name: "Check-list lors d'une vente",
      },
      {
        href: "/static/media/Diagnostic_immobilier_le_dossier_de_diagnostic_technique_(DDT).5c9a893fcfb5ad65c932.pdf",
        name: "Les diagnostics immobiliers",
      },
      // {
      //   href: "/static/media/Droits_de_mutation_a_titre_onereux_(DMTO).ebf72add71fc8a4eab62.pdf",
      //   name: "Les DMTO au 1er Juin 2024",
      // },
      {
        href: "/static/media/Le_bail_professionnel_et_le_bail_commercial.7c0de260e96410b0f346.pdf",
        name: "Le bail professionnel et le bail commercial",
      },
      {
        href: "/static/media/La_fiscalite_immobiliere_quel_taux_et_quel_droit_appliquer.502055a105b9292e9a21.pdf",
        name: "La fiscalité immobilière, quel taux et quel droit appliquer ?",
      },
      {
        href: "/static/media/La_location_pour_les_particuliers_quel_bail.f8eec69b87ff10170393.pdf",
        name: "La location pour les particuliers, quel bail ?",
      },
      // Famille
      {
        href: "/static/media/Ce_qu_il_ne_faut_pas_oublier_lors_d_une_succession_(check-list).432d6de5ea4ee29fea44.pdf",
        name: "Check-list lors de l’ouverture d’une succession",
      },
      {
        href: "/static/media/Rappel_des_droits_applicables_aux_successions_et_aux_donations.14b9c8fe4291d1a1e12b.pdf",
        name: "Droits applicables aux donations et successions",
      },
      {
        href: "/static/media/Synthese_des_exonerations_et_abattements_sur_les_successions.403f1abecb5b1b9f6aa1.pdf",
        name: "Exonérations et abattements sur les successions",
      },
      {
        href: "/static/media/Synthese_des_exonerations_et_abattements_sur_les_donations.f4490b0589748cb34163.pdf",
        name: "Exonérations et abattements sur les donations",
      },
      {
        href: "/static/media/Fiscalite_de_l_assurance_vie_droits_de_succession.2f41bf399316b64a4fb2.pdf",
        name: "La fiscalité applicable au contrat d’assurance-vie dénoué",
      },
      {
        href: "/static/media/Rappel_sur_les_regles_de_repartition_d_usufruit_et_nue-propriete.b0564a0b465203fb7334.pdf",
        name: "Barème de l’usufruit (CGI, art. 669)",
      },
    ]);

    setExpertOpinions([
      {
        href: "/static/media/liquidation_CSI_dans_donation_demembree_bien_immobilier.f5f714df1d22ff408881.pdf",
        name: "La liquidation de la CSI dans une donation démembrée d’un bien immobilier",
      },
      {
        href: "/static/media/pma_ou_amp.20f647aaaeccf946980a.pdf",
        name: "La procréation médicalement assistée (PMA) ou assistance médicale à la procréation (AMP) : quelle taxe pour quel acte ?",
      },
      {
        href: "/static/media/liquidation_participation_aux_acquets.a302cea50ff751d5e4ad.pdf",
        name: "Liquidation d’une participation aux acquêts : principes applicables à l’émolument d’acte",
      },
    ]);
  }, [isMountedRef]);

  useEffect(() => {
    var others = {
      method: "get",
      url: `${API_BASE_URL}/categories/autres`,
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("user"))?.jwt,
      },
    };
    axios(others)
      .then((response) => {
        // response.data renvoie directement le token sans json il faut donc stocker le token en async storage et faire la securité sur les autres pages si l'utilisateurs 'nest pas connecté
        if (response.status === 200 && response.data != null) {
          if (isMountedRef.current) {
            setCategoriesOther(response.data.subcategories);
          }
        } else {
          enqueueSnackbar("Une erreur est survenue", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 401 && error.response.data != null) {
          if (error.response.data.error == "Other_user_connected") {
            localStorage.removeItem("user");
            localStorage.setItem("other_user_connected", "other_user_connected");
            window.location.href = "/login";
          }
          if (error.response.data.error == "Never connected" || error.response.data.error == "Unauthorized") {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
        }
      });
  }, [isMountedRef]);

  useEffect(() => {
    var config = {
      method: "get",
      url: `${API_BASE_URL}/categories`,
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("user"))?.jwt,
      },
    };
    axios(config)
      .then((response) => {
        // response.data renvoie directement le token sans json il faut donc stocker le token en async storage et faire la securité sur les autres pages si l'utilisateurs 'nest pas connecté
        if (response.status === 200 && response.data != null) {
          if (isMountedRef.current) {
            setCategories(response.data);
          }
        } else {
          enqueueSnackbar("Une erreur est survenue", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 401 && error.response.data != null) {
          if (error.response.data.error == "Other_user_connected") {
            localStorage.removeItem("user");
            localStorage.setItem("other_user_connected", "other_user_connected");
            window.location.href = "/login";
          }
          if (error.response.data.error == "Never connected" || error.response.data.error == "Unauthorized") {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
        }
      });
  }, [isMountedRef]);

  useEffect(() => {
    var others = {
      method: "get",
      url: `${API_BASE_URL}/categories/autres`,
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("user"))?.jwt,
      },
    };
    axios(others)
      .then((response) => {
        // response.data renvoie directement le token sans json il faut donc stocker le token en async storage et faire la securité sur les autres pages si l'utilisateurs 'nest pas connecté
        if (response.status === 200 && response.data != null) {
          if (isMountedRef.current) {
            setCategoriesOther(response.data.subcategories);
          }
        } else {
          enqueueSnackbar("Une erreur est survenue", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 401 && error.response.data != null) {
          if (error.response.data.error == "Other_user_connected") {
            localStorage.removeItem("user");
            localStorage.setItem("other_user_connected", "other_user_connected");
            window.location.href = "/login";
          }
          if (error.response.data.error == "Never connected" || error.response.data.error == "Unauthorized") {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
        }
      });
  }, [isMountedRef]);

  useEffect(() => {
    var others = {
      method: "get",
      url: `${API_BASE_URL}/categories/autres`,
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("user"))?.jwt,
      },
    };
    axios(others)
      .then((response) => {
        // response.data renvoie directement le token sans json il faut donc stocker le token en async storage et faire la securité sur les autres pages si l'utilisateurs 'nest pas connecté
        if (response.status === 200 && response.data != null) {
          if (isMountedRef.current) {
            setCategoriesOther(response.data.subcategories);
          }
        } else {
          enqueueSnackbar("Une erreur est survenue", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 401 && error.response.data != null) {
          if (error.response.data.error == "Other_user_connected") {
            localStorage.removeItem("user");
            localStorage.setItem("other_user_connected", "other_user_connected");
            window.location.href = "/login";
          }
          if (error.response.data.error == "Never connected" || error.response.data.error == "Unauthorized") {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
        }
      });
  }, [isMountedRef]);

  // Recuperation data de l'essentiel emol d'acte pour la searchbar
  useEffect(() => {
    var others = {
      method: "get",
      url: `${API_BASE_URL}/essentiel_emol`,
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("user"))?.jwt,
      },
    };
    axios(others)
      .then((response) => {
        // response.data renvoie directement le token sans json il faut donc stocker le token en async storage et faire la securité sur les autres pages si l'utilisateurs 'nest pas connecté
        if (response.status === 200 && response.data != null) {
          if (isMountedRef.current) {
            setEmolActes(response.data);
          }
        } else {
          enqueueSnackbar("Une erreur est survenue", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 401 && error.response.data != null) {
          if (error.response.data.error == "Other_user_connected") {
            localStorage.removeItem("user");
            localStorage.setItem("other_user_connected", "other_user_connected");
            window.location.href = "/login";
          }
          if (error.response.data.error == "Never connected" || error.response.data.error == "Unauthorized") {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
        }
      });
  }, [isMountedRef]);

  // Recuperation data de l'essentiel fiscalite pour la searchbar
  useEffect(() => {
    var others = {
      method: "get",
      url: `${API_BASE_URL}/essentiel_fiscalite`,
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("user"))?.jwt,
      },
    };
    axios(others)
      .then((response) => {
        // response.data renvoie directement le token sans json il faut donc stocker le token en async storage et faire la securité sur les autres pages si l'utilisateurs 'nest pas connecté
        if (response.status === 200 && response.data != null) {
          if (isMountedRef.current) {
            setFiscaActes(response.data);
          }
        } else {
          enqueueSnackbar("Une erreur est survenue", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 401 && error.response.data != null) {
          if (error.response.data.error == "Other_user_connected") {
            localStorage.removeItem("user");
            localStorage.setItem("other_user_connected", "other_user_connected");
            window.location.href = "/login";
          }
          if (error.response.data.error == "Never connected" || error.response.data.error == "Unauthorized") {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
        }
      });
  }, [isMountedRef]);

  // Recuperation data de l'essentiel droits fixes pour la searchbar
  useEffect(() => {
    var others = {
      method: "get",
      url: `${API_BASE_URL}/essentiel_droits_fixes`,
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("user"))?.jwt,
      },
    };
    axios(others)
      .then((response) => {
        // response.data renvoie directement le token sans json il faut donc stocker le token en async storage et faire la securité sur les autres pages si l'utilisateurs 'nest pas connecté
        if (response.status === 200 && response.data != null) {
          if (isMountedRef.current) {
            setDroitsFixesActes(response.data);
          }
        } else {
          enqueueSnackbar("Une erreur est survenue", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 401 && error.response.data != null) {
          if (error.response.data.error == "Other_user_connected") {
            localStorage.removeItem("user");
            localStorage.setItem("other_user_connected", "other_user_connected");
            window.location.href = "/login";
          }
          if (error.response.data.error == "Never connected" || error.response.data.error == "Unauthorized") {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
        }
      });
  }, [isMountedRef]);

  useEffect(() => {
    if (allFavoris !== null && allFavoris.length > 0) {
      try {
        setAllFavoris(JSON.parse(allFavoris));
      } catch (e) {}
    }
  }, [isMountedRef]);

  function returnStar(item) {
    if (allFavoris == null) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.847"
          height="19.011"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 512 512"
        >
          <path
            fill="none"
            stroke="#ffffff"
            strokeLinejoin="round"
            strokeWidth="20"
            d="M480 208H308L256 48l-52 160H32l140 96l-54 160l138-100l138 100l-54-160Z"
          />
        </svg>
      );
    }
    if (allFavoris.hasOwnProperty(item.id)) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.847"
          height="19.011"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 512 512"
        >
          <path
            fill="#ffffff"
            d="M394 480a16 16 0 0 1-9.39-3L256 383.76L127.39 477a16 16 0 0 1-24.55-18.08L153 310.35L23 221.2a16 16 0 0 1 9-29.2h160.38l48.4-148.95a16 16 0 0 1 30.44 0l48.4 149H480a16 16 0 0 1 9.05 29.2L359 310.35l50.13 148.53A16 16 0 0 1 394 480Z"
          />
        </svg>
      );
    } else {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.847"
          height="19.011"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 512 512"
        >
          <path
            fill="none"
            stroke="#ffffff"
            strokeLinejoin="round"
            strokeWidth="20"
            d="M480 208H308L256 48l-52 160H32l140 96l-54 160l138-100l138 100l-54-160Z"
          />
        </svg>
      );
    }
  }

  function onClickFavoris(id) {
    var config = {
      method: "get",
      url: `${API_BASE_URL}/favoris/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("user"))?.jwt,
      },
    };
    axios(config)
      .then((response) => {
        if (response.status === 200 && response.data != null) {
          localStorage.setItem("favoris", response.data);
          if (response.data !== null) setAllFavoris(JSON.parse(response.data));
          else setAllFavoris(response.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401 && error.response.data != null) {
          if (error.response.data.error == "Other_user_connected") {
            localStorage.removeItem("user");
            localStorage.setItem("other_user_connected", "other_user_connected");
            window.location.href = "/login";
          }
          if (error.response.data.error == "Never connected" || error.response.data.error == "Unauthorized") {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
        }
      });
  }

  const handleMouseEnter = (item) => {
    setHoveredItem(item);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ctnSearchBarRef.current && !ctnSearchBarRef.current.contains(event.target)) {
        setSearchValueInput("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const searchWords = searchValueInput.toLowerCase().split(" ");

  useEffect(() => {
    const filteredResultsSimu = simulateurs.filter((item) => {
      const itemName = item.name.toLowerCase();
      return searchWords.every((word) => itemName.includes(word));
    });

    const options = {
      keys: ["name"],
      threshold: 0.3,
    };

    const fuse = new Fuse(simulateurs, options);

    const searchResults = fuse.search(searchValueInput.toLowerCase());

    const newSimulateursProposal = searchResults.map((result, index) => {
      const item = result.item;
      const itemName = item.name;
      const searchTerm = searchValueInput.toLowerCase();
      const parts = itemName.split(new RegExp(`(${searchTerm})`, "gi"));
      const isFirstItem = index === 0 && !simulateurAdded;

      return (
        <ToolTipSearch title={item.name}>
          <div
            key={item.id}
            className={"itemProposal"}
            style={{
              textAlign: isFirstItem ? "left" : "right",
            }}
            onClick={() => {
              if (item.subcategorie[0].shortname == "DMTG")
                window.location.href = "/categorie/" + item.subcategorie[0].categorie.url_name + "/dmtg/" + item.id;
              else if (item.subcategorie[0].categorie.url_name == "autres")
                window.location.href = "/categorie/" + item.subcategorie[0].categorie.url_name + "/others/" + item.id;
              else {
                window.location.href =
                  "/categorie/" + item.subcategorie[0].categorie.url_name + "/simulateur/" + item.id;
              }

              ReactGA.event({
                category: "Barre de recherche",
                action: "Clic sur barre de recherche",
                label: "Clic sur barre de recherche",
              });
            }}
            onMouseEnter={() => setHoveredItem(item)}
            onMouseLeave={() => setHoveredItem(null)}
          >
            {isFirstItem ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div className={"firstItemSearch"}>Simulateurs -</div>
                <div className={"firstItemText"}>
                  {hoveredItem === item
                    ? item.name
                    : item.name.length > 45
                    ? `${item.name.slice(0, 45)}...`
                    : item.name}
                </div>
              </div>
            ) : item.name.length > 45 ? (
              `${item.name.slice(0, 45)}...`
            ) : (
              item.name
            )}
          </div>
        </ToolTipSearch>
      );
    });

    const filteredResultsFiches = fiches.filter((item) => {
      const itemName = item.name.toLowerCase();
      return searchWords.every((word) => itemName.includes(word));
    });

    const fuseFiches = new Fuse(fiches, options);

    const searchResultsFiche = fuseFiches.search(searchValueInput.toLowerCase());

    const newFichesProposal = searchResultsFiche.map((result, index) => {
      const item = result.item;
      const itemName = item.name;
      const searchTerm = searchValueInput.toLowerCase();
      const parts = itemName.split(new RegExp(`(${searchTerm})`, "gi"));
      const isFirstItem = index === 0 && !ficheAdded;

      return (
        <ToolTipSearch title={item.name}>
          <div
            key={item.id}
            className={"itemProposal"}
            style={{
              width: "95%",
              marginLeft: "2.5%",
              letterSpacing: 1,
              height: "30px",
              lineHeight: "30px",
              cursor: "pointer",
              color: "black",
              textAlign: isFirstItem ? "left" : "right",
            }}
            onClick={() => {
              var a = document.createElement("a");
              a.href = item.href;
              a.setAttribute("target", "_blank");
              a.click();

              ReactGA.event({
                category: "Barre de recherche",
                action: "Clic sur barre de recherche",
                label: "Clic sur barre de recherche",
              });
            }}
            onMouseEnter={() => setHoveredItem(item)}
            onMouseLeave={() => setHoveredItem(null)}
          >
            {isFirstItem ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div className={"firstItemSearch"}>Fiches pratiques -</div>
                <div className={"firstItemText"}>
                  {hoveredItem === item
                    ? item.name
                    : item.name.length > 40
                    ? `${item.name.slice(0, 40)}...`
                    : item.name}
                </div>
              </div>
            ) : item.name.length > 40 ? (
              `${item.name.slice(0, 40)}...`
            ) : (
              item.name
            )}
          </div>
        </ToolTipSearch>
      );
    });

    const filteredResultsExpert = expertOpinions.filter((item) => {
      const itemName = item.name.toLowerCase();
      return searchWords.every((word) => itemName.includes(word));
    });

    const fuseExpert = new Fuse(expertOpinions, options);

    const searchResultsExpert = fuseExpert.search(searchValueInput.toLowerCase());

    const newExpertProposal = searchResultsExpert.map((result, index) => {
      const item = result.item;
      const itemName = item.name;
      const searchTerm = searchValueInput.toLowerCase();
      const parts = itemName.split(new RegExp(`(${searchTerm})`, "gi"));
      const isFirstItem = index === 0 && !ficheAdded;

      return (
        <ToolTipSearch title={item.name}>
          <div
            key={item.id}
            className={"itemProposal"}
            style={{
              width: "95%",
              marginLeft: "2.5%",
              letterSpacing: 1,
              height: "30px",
              lineHeight: "30px",
              cursor: "pointer",
              color: "black",
              textAlign: isFirstItem ? "left" : "right",
            }}
            onClick={() => {
              var a = document.createElement("a");
              a.href = item.href;
              a.setAttribute("target", "_blank");
              a.click();
              ReactGA.event({
                category: "Barre de recherche",
                action: "Clic sur barre de recherche",
                label: "Clic sur barre de recherche",
              });
            }}
            onMouseEnter={() => setHoveredItem(item)}
            onMouseLeave={() => setHoveredItem(null)}
          >
            {isFirstItem ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    textAlign: "left",
                    lineHeight: "30px",
                    fontWeight: "bold",
                    color: "#5e91b6",
                  }}
                >
                  Avis d'experts -
                </div>
                <div
                  style={{
                    textAlign: "right",
                    lineHeight: "30px",
                  }}
                >
                  {item.name.length > 40
                    ? `${`${item.name.substring(0, 1).toUpperCase()}${item.name
                        .substring(1, item.name.length)
                        .toLowerCase()}`.slice(0, 40)}...`
                    : `${item.name.substring(0, 1).toUpperCase()}${item.name
                        .substring(1, item.name.length)
                        .toLowerCase()}`}
                </div>
              </div>
            ) : item.name.length > 40 ? (
              `${`${item.name.substring(0, 1).toUpperCase()}${item.name
                .substring(1, item.name.length)
                .toLowerCase()}`.slice(0, 40)}...`
            ) : (
              `${item.name.substring(0, 1).toUpperCase()}${item.name.substring(1, item.name.length).toLowerCase()}`
            )}
          </div>
        </ToolTipSearch>
      );
    });

    // get emol_actes
    const filteredResultsEmolActe = emolActes.filter((item) => {
      const itemName = item.actes.toLowerCase();
      return searchWords.every((word) => itemName.includes(word));
    });
    const optionsEmolActe = {
      keys: ["actes"],
      threshold: 0.3,
    };
    const fuseEmolActe = new Fuse(emolActes, optionsEmolActe);

    const searchResultsEmolActe = fuseEmolActe.search(searchValueInput.toLowerCase());
    const uniqueResults = searchResultsEmolActe.reduce((acc, result) => {
      const acte = result.item.actes; // Champ "actes" dans le tableau
      if (!acc.some((item) => item.item.actes === acte)) {
        acc.push(result);
      }
      return acc;
    }, []);
    const newEmolActeProposal = uniqueResults.map((result, index) => {
      const item = result.item;
      const itemName = item.actes;
      const searchTerm = searchValueInput.toLowerCase();
      const parts = itemName.split(new RegExp(`(${searchTerm})`, "gi"));
      const isFirstItem = index === 0 && !ficheAdded;

      return (
        <ToolTipSearch title={item.actes}>
          <div
            key={item.id}
            className={"itemProposal"}
            style={{
              width: "95%",
              marginLeft: "2.5%",
              letterSpacing: 1,
              height: "30px",
              lineHeight: "30px",
              cursor: "pointer",
              color: "black",
              textAlign: isFirstItem ? "left" : "right",
            }}
            onClick={() => {
              const indexEmol = emolActes.findIndex((itemEmol) => itemEmol.n_acte == item.n_acte);
              navigateToPage(`/tarif_des_notaires#0#${indexEmol}`);
              ReactGA.event({
                category: "Barre de recherche",
                action: "Clic sur barre de recherche",
                label: "Clic sur barre de recherche",
              });
            }}
            onMouseEnter={() => setHoveredItem(item)}
            onMouseLeave={() => setHoveredItem(null)}
          >
            {isFirstItem ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    textAlign: "left",
                    lineHeight: "30px",
                    fontWeight: "bold",
                    color: "#5e91b6",
                  }}
                >
                  Émoluments d'actes -
                </div>
                <div
                  style={{
                    textAlign: "right",
                    lineHeight: "30px",
                  }}
                >
                  {item.actes.length > 40
                    ? `${`${item.actes.substring(0, 1).toUpperCase()}${item.actes
                        .substring(1, item.actes.length)
                        .toLowerCase()}`.slice(0, 40)}...`
                    : `${item.actes.substring(0, 1).toUpperCase()}${item.actes
                        .substring(1, item.actes.length)
                        .toLowerCase()}`}
                </div>
              </div>
            ) : item.actes.length > 40 ? (
              `${`${item.actes.substring(0, 1).toUpperCase()}${item.actes
                .substring(1, item.actes.length)
                .toLowerCase()}`.slice(0, 40)}...`
            ) : (
              `${item.actes.substring(0, 1).toUpperCase()}${item.actes.substring(1, item.actes.length).toLowerCase()}`
            )}
          </div>
        </ToolTipSearch>
      );
    });
    /// fin emol acte

    // get fisca_actes
    const filteredResultsFiscaActe = fiscaActes.filter((item) => {
      const itemName = item.actes.toLowerCase();
      return searchWords.every((word) => itemName.includes(word));
    });
    const optionsFiscaActe = {
      keys: ["actes"],
      threshold: 0.3,
    };
    const fuseFiscaActe = new Fuse(fiscaActes, optionsFiscaActe);

    const searchResultsFiscaActe = fuseFiscaActe.search(searchValueInput.toLowerCase());
    const uniqueFiscaResults = searchResultsFiscaActe.reduce((acc, result) => {
      const acteFisca = result.item.actes; // Champ "actes" dans le tableau
      if (!acc.some((item) => item.item.actes === acteFisca)) {
        acc.push(result);
      }
      return acc;
    }, []);
    const newFiscaActeProposal = uniqueFiscaResults.map((result, index) => {
      const item = result.item;
      const itemName = item.actes;
      const searchTerm = searchValueInput.toLowerCase();
      const parts = itemName.split(new RegExp(`(${searchTerm})`, "gi"));
      const isFirstItem = index === 0 && !ficheAdded;

      return (
        <ToolTipSearch title={item.actes}>
          <div
            key={item.id}
            className={"itemProposal"}
            style={{
              width: "95%",
              marginLeft: "2.5%",
              letterSpacing: 1,
              height: "30px",
              lineHeight: "30px",
              cursor: "pointer",
              color: "black",
              textAlign: isFirstItem ? "left" : "right",
            }}
            onClick={() => {
              const indexFisca = fiscaActes.findIndex((itemFisca) => itemFisca.n_acte == item.n_acte);
              navigateToPage(`/tarif_des_notaires#1#${indexFisca}`);
              ReactGA.event({
                category: "Barre de recherche",
                action: "Clic sur barre de recherche",
                label: "Clic sur barre de recherche",
              });
            }}
            onMouseEnter={() => setHoveredItem(item)}
            onMouseLeave={() => setHoveredItem(null)}
          >
            {isFirstItem ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    textAlign: "left",
                    lineHeight: "30px",
                    fontWeight: "bold",
                    color: "#5e91b6",
                  }}
                >
                  Fiscalité -
                </div>
                <div
                  style={{
                    textAlign: "right",
                    lineHeight: "30px",
                  }}
                >
                  {item.actes.length > 40
                    ? `${`${item.actes.substring(0, 1).toUpperCase()}${item.actes
                        .substring(1, item.actes.length)
                        .toLowerCase()}`.slice(0, 40)}...`
                    : `${item.actes.substring(0, 1).toUpperCase()}${item.actes
                        .substring(1, item.actes.length)
                        .toLowerCase()}`}
                </div>
              </div>
            ) : item.actes.length > 40 ? (
              `${`${item.actes.substring(0, 1).toUpperCase()}${item.actes
                .substring(1, item.actes.length)
                .toLowerCase()}`.slice(0, 40)}...`
            ) : (
              `${item.actes.substring(0, 1).toUpperCase()}${item.actes.substring(1, item.actes.length).toLowerCase()}`
            )}
          </div>
        </ToolTipSearch>
      );
    });
    // fin fisca acte

    // get droits_fixes_actes
    const filteredResultsDroitsFixesActe = droitsFixesActes.filter((item) => {
      const itemName = item.actes.toLowerCase();
      return searchWords.every((word) => itemName.includes(word));
    });
    const optionsDroitsFixesActe = {
      keys: ["actes"],
      threshold: 0.3,
    };
    const fuseDroitsFixesActe = new Fuse(droitsFixesActes, optionsDroitsFixesActe);

    const searchResultsDroitsFixesActe = fuseDroitsFixesActe.search(searchValueInput.toLowerCase());
    const uniqueDroitsFixesResults = searchResultsDroitsFixesActe.reduce((acc, result) => {
      const acteDroitsFixes = result.item.actes; // Champ "actes" dans le tableau
      if (!acc.some((item) => item.item.actes === acteDroitsFixes)) {
        acc.push(result);
      }
      return acc;
    }, []);
    const newDroitsFixesActeProposal = uniqueDroitsFixesResults.map((result, index) => {
      const item = result.item;
      const itemName = item.actes;
      const searchTerm = searchValueInput.toLowerCase();
      const parts = itemName.split(new RegExp(`(${searchTerm})`, "gi"));
      const isFirstItem = index === 0 && !ficheAdded;

      return (
        <ToolTipSearch title={item.actes}>
          <div
            key={item.id}
            className={"itemProposal"}
            style={{
              width: "95%",
              marginLeft: "2.5%",
              letterSpacing: 1,
              height: "30px",
              lineHeight: "30px",
              cursor: "pointer",
              color: "black",
              textAlign: isFirstItem ? "left" : "right",
            }}
            onClick={() => {
              const indexDroitsFixes = droitsFixesActes.findIndex(
                (itemDroitsFixes) => itemDroitsFixes.n_acte == item.n_acte
              );
              navigateToPage(`/tarif_des_notaires#2#${indexDroitsFixes}`);
              ReactGA.event({
                category: "Barre de recherche",
                action: "Clic sur barre de recherche",
                label: "Clic sur barre de recherche",
              });
            }}
            onMouseEnter={() => setHoveredItem(item)}
            onMouseLeave={() => setHoveredItem(null)}
          >
            {isFirstItem ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    textAlign: "left",
                    lineHeight: "30px",
                    fontWeight: "bold",
                    color: "#5e91b6",
                  }}
                >
                  Droits fixes -
                </div>
                <div
                  style={{
                    textAlign: "right",
                    lineHeight: "30px",
                  }}
                >
                  {item.actes.length > 40
                    ? `${`${item.actes.substring(0, 1).toUpperCase()}${item.actes
                        .substring(1, item.actes.length)
                        .toLowerCase()}`.slice(0, 40)}...`
                    : `${item.actes.substring(0, 1).toUpperCase()}${item.actes
                        .substring(1, item.actes.length)
                        .toLowerCase()}`}
                </div>
              </div>
            ) : item.actes.length > 40 ? (
              `${`${item.actes.substring(0, 1).toUpperCase()}${item.actes
                .substring(1, item.actes.length)
                .toLowerCase()}`.slice(0, 40)}...`
            ) : (
              `${item.actes.substring(0, 1).toUpperCase()}${item.actes.substring(1, item.actes.length).toLowerCase()}`
            )}
          </div>
        </ToolTipSearch>
      );
    });
    /// fin droits fixes acte

    if (searchValueInput.length === 0) {
      setSimulateursProposal(null);
      setExpertOpinionsProposal(null);
      setFichesProposal(null);
      setSearchValueInput("");
    } else {
      setSimulateursProposal(newSimulateursProposal);
      setFichesProposal(newFichesProposal);
      setExpertOpinionsProposal(newExpertProposal);
      setEmolActeProposal(newEmolActeProposal);
      setFiscaActeProposal(newFiscaActeProposal);
      setDroitsFixesActeProposal(newDroitsFixesActeProposal);
    }
  }, [searchValueInput]);

  const handleBlur = () => {
    setExpertOpinionsProposal(null);
    setSimulateursProposal(null);
    setFichesProposal(null);
  };

  const openMenu = () => {
    if (!isOpen) {
      setIsOpen(true);
    }
  };

  const handleMenuClick = (anchor) => {
    // Redirige vers /tarif_des_notaires avec le fragment
    window.location.assign(`/tarif_des_notaires${anchor}`);
  };

  return (
    <>
      <div className="burger-menu" onClick={() => setIsOpen(!isOpen)}>
        &#9776;
      </div>
      <div className={`lateralMenu-container ${isOpen ? "open" : ""}`}>
        <div className="lateralMenu" ref={sidebarRef} style={{ width: `${width}px` }}>
          <div className="lateralMenu-collapse-icon" onClick={toggleCollapse}>
            {isLateralMenuCollapsed ? "➔" : "←"}
          </div>
          {!isLateralMenuCollapsed && <Breadcrumb />}
          <div className="lateralMenu-content">
            <div className="lateralMenu-ctnSearchBar">
              <span className="lateralMenu-input">
                <svg
                  id="Calque_1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 45.3 45.3"
                  width={30}
                  height={30}
                  fill="#ffffff"
                  className="lateralMenu-pictoLoupeBreadcrumb"
                  onClick={toggleCollapse}
                >
                  <path d="M40.17,5.17C35.98.96,29.94-.85,24.12.37c-5.82,1.22-10.62,5.3-12.77,10.84-2.15,5.54-1.36,11.79,2.11,16.62L1.16,40.14c-.67.49-1.09,1.26-1.15,2.09-.06.83.24,1.64.83,2.23.59.59,1.4.89,2.23.83.83-.06,1.59-.48,2.09-1.15l12.31-12.3c4.82,3.46,11.07,4.26,16.6,2.12,5.54-2.14,9.61-6.94,10.84-12.75,1.23-5.8-.55-11.84-4.74-16.05h0ZM36.82,26.64c-3.66,3.64-9.15,4.72-13.92,2.74-4.77-1.98-7.88-6.64-7.88-11.8s3.11-9.82,7.88-11.8c4.77-1.98,10.26-.9,13.92,2.74,2.41,2.4,3.76,5.66,3.76,9.06s-1.35,6.66-3.76,9.06h0Z" />
                </svg>

                <div className={`${isLateralMenuCollapsed ? "collapsed" : ""}`}>
                  <div className="lateralMenu-searchContainer">
                    <input
                      type={"text"}
                      className="lateralMenu-searchBar"
                      placeholder={"Recherche rapide"}
                      value={searchValueInput}
                      onChange={(e) => setSearchValueInput(e.target.value)}
                    />
                    <span
                      className="lateralMenu-clear-icon"
                      onClick={() => {
                        setSearchValueInput("");
                      }}
                    >
                      ✕
                    </span>
                  </div>
                </div>
              </span>
            </div>
            {searchValueInput !== "" ? (
              <div ref={ctnSearchBarRef} className="lateralMenu-ctnSearchBarProposes">
                {simulateursProposal} {fichesProposal} {expertOpinionsProposal} {emolActeProposal} {fiscaActeProposal}{" "}
                {droitsFixesActeProposal}
              </div>
            ) : null}

            <CollapseMenu
              title="Simulateurs de frais"
              icon={
                <svg
                  id="Calque_1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 27.87 27.84"
                  width={25}
                  height={25}
                  fill="#ffffff"
                  onClick={toggleCollapse}
                >
                  <path d="M10.52,0H1.72C.77,0,0,.77,0,1.72v8.81c0,.94.77,1.71,1.72,1.71h8.81c.94,0,1.72-.77,1.72-1.71V1.72c0-.95-.77-1.72-1.72-1.72ZM11.24,10.52c0,.39-.32.71-.72.71H1.72c-.39,0-.72-.32-.72-.71V1.72c0-.39.32-.72.72-.72h8.81c.4,0,.72.32.72.72,0,0,0,8.81,0,8.81Z" />
                  <polygon points="6.62 2.98 5.62 2.98 5.62 5.62 2.98 5.62 2.98 6.62 5.62 6.62 5.62 9.26 6.62 9.26 6.62 6.62 9.26 6.62 9.26 5.62 6.62 5.62 6.62 2.98" />
                  <path d="M26.15,0h-8.81c-.94,0-1.72.77-1.72,1.72v8.81c0,.94.77,1.71,1.72,1.71h8.81c.94,0,1.72-.77,1.72-1.71V1.72c0-.95-.77-1.72-1.72-1.72ZM26.87,10.52c0,.39-.32.71-.72.71h-8.81c-.4,0-.72-.32-.72-.71V1.72c0-.39.32-.72.72-.72h8.81c.4,0,.72.32.72.72v8.81Z" />
                  <polygon points="23.61 3.55 21.75 5.41 19.88 3.55 19.18 4.25 21.04 6.12 19.18 7.98 19.88 8.69 21.75 6.82 23.61 8.69 24.32 7.98 22.45 6.12 24.32 4.25 23.61 3.55" />
                  <path d="M10.52,15.6H1.72c-.95,0-1.72.77-1.72,1.71v8.81c0,.95.77,1.72,1.72,1.72h8.81c.94,0,1.72-.77,1.72-1.72v-8.81c0-.95-.77-1.71-1.72-1.71ZM11.24,26.12c0,.4-.32.72-.72.72H1.72c-.39,0-.72-.32-.72-.72v-8.81c0-.39.32-.71.72-.71h8.81c.4,0,.72.32.72.71,0,0,0,8.81,0,8.81Z" />
                  <rect x="2.98" y="21.22" width="6.28" height="1" />
                  <path d="M26.15,15.6h-8.81c-.94,0-1.72.77-1.72,1.71v8.81c0,.95.77,1.72,1.72,1.72h8.81c.94,0,1.72-.77,1.72-1.72v-8.81c0-.95-.77-1.71-1.72-1.71ZM26.87,26.12c0,.4-.32.72-.72.72h-8.81c-.4,0-.72-.32-.72-.72v-8.81c0-.39.32-.71.72-.71h8.81c.4,0,.72.32.72.71v8.81Z" />
                  <rect x="18.61" y="21.22" width="6.28" height="1" transform="translate(-8.99 21.74) rotate(-45)" />
                  <circle cx="20.26" cy="20.23" r=".83" />
                  <circle cx="23.24" cy="23.21" r=".83" />
                </svg>
              }
              isParentCollapsed={isLateralMenuCollapsed}
            >
              <ul className="lateralMenu-bullet">
                {categories.map((value) => {
                  if (value.categorie_id != 5) {
                    return (
                      <li
                        className="listElemHome"
                        onClick={() => {
                          ReactGA.event({
                            category: "LateralMenu",
                            action: "Clic sur simu de frais",
                            label: "LateralMenu_simuFrais",
                          });
                          window.location = `/categorie/${value.url_name}`;
                        }}
                      >
                        {value.categorie_name}
                      </li>
                    );
                  }
                  return <></>;
                })}
              </ul>
            </CollapseMenu>

            <CollapseMenu
              title="Calculateurs divers"
              icon={
                <svg
                  id="Calque_1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 93.48 87.03"
                  width={25}
                  height={25}
                  fill="#ffffff"
                  onClick={toggleCollapse}
                >
                  <path d="M93.46,48.98c.08-.86-.36-1.71-1.18-2.1l-21.12-9.94V12.95s-.02-.1-.02-.14c.08-.86-.36-1.71-1.18-2.1L47.63.19s-.06-.02-.08-.03c-.07-.03-.15-.06-.22-.08-.06-.02-.12-.03-.18-.05-.07-.01-.14-.02-.21-.03-.07,0-.13-.01-.2-.01s-.13,0-.2.01c-.07,0-.14.01-.21.03-.06.01-.12.03-.18.05-.07.02-.15.05-.22.08-.03.01-.06.02-.08.03l-22.32,10.51c-.82.39-1.27,1.24-1.18,2.1,0,.05-.02.09-.02.14v23.98L1.2,46.87c-.82.39-1.27,1.24-1.18,2.1,0,.05-.02.1-.02.15v25.31c0,.81.47,1.55,1.2,1.89l22.32,10.51c.07.03.14.05.21.07.05.02.1.04.16.06.17.04.35.07.52.07s.35-.03.52-.07c.06-.01.11-.04.16-.06.07-.02.14-.04.21-.07l21.43-10.09,21.43,10.09c.07.03.14.05.21.07.05.02.1.04.16.05.17.05.35.07.52.07s.35-.03.53-.07c.05-.01.1-.04.16-.05.07-.02.14-.04.21-.07l22.32-10.51c.73-.35,1.2-1.08,1.2-1.89v-25.31s-.01-.1-.02-.14ZM69.06,57.32l-17.78-8.38,17.78-8.37,17.78,8.37-17.78,8.38ZM24.42,57.32l-17.78-8.38,17.78-8.37,17.78,8.37-17.78,8.38ZM46.74,4.4l17.78,8.37-17.78,8.38-17.78-8.38,17.78-8.37ZM44.65,45.47l-18.14-8.54v-20.68l18.14,8.54v20.68ZM48.83,24.79l18.14-8.54v20.68l-18.14,8.54s0-20.68,0-20.68ZM48.83,52.42l18.14,8.54v20.68l-18.14-8.54s0-20.68,0-20.68ZM4.19,52.42l18.14,8.54v20.68l-18.14-8.54s0-20.68,0-20.68ZM44.65,73.1l-18.14,8.54v-20.68l18.14-8.54v20.68ZM89.29,73.1l-18.14,8.54v-20.68l18.14-8.54v20.68Z" />
                </svg>
              }
              isParentCollapsed={isLateralMenuCollapsed}
            >
              <ul className="lateralMenu-bullet">
                {categoriesOther.length > 0 ? (
                  categoriesOther["0"].simulateur.map((value) => {
                    if (value.id != 107 && value.id != 108) {
                      return (
                        <li
                          className="listElemHome"
                          onClick={() => {
                            ReactGA.event({
                              category: "LateralMenu",
                              action: "Clic sur Calculateurs divers",
                              label: "LateralMenu_calcDivers",
                            });
                            if (dmtg.includes(value.id)) {
                              window.location = `/categorie/autres/dmtg/${value.id}`;
                            } else if (others.includes(value.id)) {
                              window.location = `/categorie/autres/others/${value.id}`;
                            }
                          }}
                        >
                          {value.name}
                        </li>
                      );
                    }
                    return <></>;
                  })
                ) : (
                  <></>
                )}
              </ul>
            </CollapseMenu>

            <CollapseMenu
              title="L’essentiel de la taxe des actes"
              icon={
                <svg
                  id="Calque_1"
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 91.67 81.25"
                  onClick={toggleCollapse}
                >
                  <path
                    d="M90.62,18.75h-3.12v-3.12c0-.46-.31-.87-.75-1-1.81-.52-3.65-.94-5.5-1.28V5.21c0-.53-.39-.97-.91-1.04-13.27-1.92-27.21,4.56-34.32,13.72-2.36-4.28-7.07-10.73-15.35-14.66C26.3,1.16,21.6.08,16.68,0c-.29,0-.55.11-.75.3-.2.2-.31.46-.31.74v11.56c-3.64.36-7.24,1.02-10.7,2.02-.45.13-.75.54-.75,1v3.12H1.04c-.57,0-1.04.46-1.04,1.04v60.42c0,.57.46,1.04,1.04,1.04h89.58c.57,0,1.04-.46,1.04-1.04V19.79c0-.57-.47-1.04-1.05-1.04h0ZM85.41,16.41v58.4c-6.24-.99-12.57-1.28-18.82-.85-6.75.46-12.49,2.28-17.25,3.93,3.32-3.32,8.09-6.93,14.55-9.2,5.21-1.83,10.67-2.52,16.23-2.03.29.02.58-.07.79-.27.21-.2.34-.48.34-.77V15.46c1.39.27,2.79.58,4.17.95h0ZM62.86,8.27c6.38-2.4,12.25-2.52,16.3-2.12v58.36c-12.19-1.04-25.28,4.98-32.29,12.93V20.14c2.95-3.83,8.07-8.9,15.99-11.88ZM17.7,2.12c12.83.3,23.22,9.57,27.08,17.92v56.53c-5.01-7.79-15.71-15.37-27.08-16.08V2.12ZM6.25,16.42c3.04-.83,6.19-1.39,9.37-1.72v46.76c0,.55.43,1,.98,1.04,4.25.27,8.34,1.3,12.13,3.03,7.35,3.36,12.03,8.75,14.69,12.74-4.97-1.74-11.08-3.81-18.35-4.31-6.26-.43-12.58-.14-18.82.85V16.41s0,0,0,0ZM2.08,20.84h2.08v55.21c0,.31.14.6.37.8.23.2.55.28.85.23,6.47-1.13,13.04-1.47,19.54-1.03,5.56.38,10.47,1.73,14.68,3.13H2.08V20.83h0ZM89.58,79.17h-37.53c4.21-1.39,9.12-2.75,14.68-3.13,6.5-.45,13.07-.1,19.54,1.03.3.05.61-.03.85-.23.23-.2.37-.49.37-.8V20.83s2.08,0,2.08,0v58.33h0Z"
                    fill="#ffffff"
                  />
                </svg>
              }
              isParentCollapsed={isLateralMenuCollapsed}
            >
              <ul className="lateralMenu-bullet">
                <li
                  className="listElemHome"
                  onClick={() => {
                    ReactGA.event({
                      category: "LateralMenu",
                      action: "Clic sur emolActes",
                      label: "lateralMenu_emolActes",
                    });
                    handleMenuClick("#emolActes");
                  }}
                >
                  Émoluments d'actes
                </li>
                <li
                  className="listElemHome"
                  onClick={() => {
                    ReactGA.event({
                      category: "LateralMenu",
                      action: "Clic sur emolForm",
                      label: "lateralMenu_emolForm",
                    });
                    handleMenuClick("#emolForm");
                  }}
                >
                  Émoluments de formalités
                </li>
                <li
                  className="listElemHome"
                  onClick={() => {
                    ReactGA.event({
                      category: "LateralMenu",
                      action: "Clic sur fisca",
                      label: "lateralMenu_fisca",
                    });
                    handleMenuClick("#fisca");
                  }}
                >
                  Fiscalité
                </li>
                <li
                  className="listElemHome"
                  onClick={() => {
                    ReactGA.event({
                      category: "LateralMenu",
                      action: "Clic sur droitsFixes",
                      label: "lateralMenu_droitsFixes",
                    });
                    handleMenuClick("#droitsFixes");
                  }}
                >
                  Droits fixes
                </li>
                <li
                  className="listElemHome"
                  onClick={() => {
                    ReactGA.event({
                      category: "LateralMenu",
                      action: "Clic sur debours",
                      label: "lateralMenu_debours",
                    });
                    handleMenuClick("#debours");
                  }}
                >
                  Débours
                </li>
                <li
                  className="listElemHome"
                  onClick={() => {
                    ReactGA.event({
                      category: "LateralMenu",
                      action: "Clic sur fichesPratiques",
                      label: "lateralMenu_fichesPratiques",
                    });
                    handleMenuClick("#fichesPratiques");
                  }}
                >
                  Fiches pratiques
                </li>
              </ul>
            </CollapseMenu>

            {/* <div className="collapsibleCard">
              <span className="collapsibleCardFlex">
                <div className="collapsibleCardIcon">
                  <svg
                    id="Calque_1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="27"
                    viewBox="0 0 91.67 81.25"
                    onClick={toggleCollapse}
                  >
                    <path
                      d="M14.5,0c7.6,0,13.8,6.1,13.8,13.7s-6.1,13.8-13.7,13.8S.8,21.4.8,13.8h0c0-7.6,6.1-13.8,13.7-13.8ZM53.1,77.6H16.4C7.1,77.4-.2,69.7,0,60.4c.2-9,7.4-16.2,16.4-16.4h8.1c.6,0,1.1.5,1.1,1.1s-.5,1.1-1.1,1.1h-8.1c-8,.2-14.4,6.9-14.2,14.9.2,7.7,6.4,14,14.2,14.2h36.7l-3.5-3.5c-.4-.4-.4-1.2,0-1.6h0c.4-.4,1.1-.4,1.6,0h0l5.4,5.4c.4.4.4,1.2,0,1.6h0l-5.4,5.4c-.4.5-1.1.5-1.6.1s-.5-1.1-.1-1.6l.1-.1,3.5-3.5h0v.1ZM73.2,49.7l-3.4-3.5h5.4c9.3-.2,16.6-7.9,16.4-17.2-.2-9-7.4-16.2-16.4-16.4h-39.5c-.6,0-1.1.5-1.1,1.1s.5,1.1,1.1,1.1h39.4c8,.2,14.4,6.9,14.2,14.9-.2,7.7-6.4,14-14.2,14.2h-5.4l3.5-3.5c.4-.4.4-1.1,0-1.6h0c-.4-.4-1.2-.4-1.6,0h0l-5.4,5.4c-.4.4-.4,1.2,0,1.6h0l5.4,5.4c.4.4,1.2.4,1.6,0h0c.4-.4.4-1.1,0-1.6h0v.1ZM70.6,77.3c-.3-.5-.1-1.2.4-1.5h0c.5-.3,1.2-.1,1.5.4h0l4.1,3.6,6.7-7.8c.5-.3,1.2-.1,1.5.4s.2,1.2-.3,1.5l-7.7,8.3c-.5.4-1.2.2-1.6-.3h0l-4.6-4.5v-.1ZM77.1,62.7c-7.6,0-13.8,6.1-13.8,13.7s6.1,13.8,13.7,13.8,13.8-6.1,13.8-13.7h0c0-7.6-6.1-13.7-13.7-13.8ZM45.8,31.4c-7.6,0-13.8,6.1-13.8,13.7s6.1,13.8,13.7,13.8,13.8-6.1,13.8-13.7h0c0-7.6-6.1-13.7-13.7-13.8Z"
                      fill="#ffffff"
                    />
                  </svg>
                </div>
                <div className="collapsibleCardHeader">
                  <span
                    onClick={() => (window.location = `/AnalysePatrimoniale`)}
                    className={`${isLateralMenuCollapsed ? "collapsed" : ""}`}
                  >
                    Analyse patrimoniale
                  </span>
                </div>
              </span>
            </div> */}

            <CollapseMenu
              title="Mes actes favoris"
              icon={
                <svg
                  id="Calque_1"
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 54.4 52.04"
                  onClick={toggleCollapse}
                >
                  <path
                    d="M1.2,19.9c-.1,0-.2.1-.2.2s0,.2.1.2l15,10.9c.6.4.8,1.2.6,1.8l-5.8,17.6c0,.1,0,.3.2.3h.2l14.9-10.8c.6-.4,1.3-.4,1.9,0l15,10.9c.1.1.3,0,.3-.1s.1-.1,0-.2l-5.7-17.7c-.2-.7,0-1.4.6-1.8l15-10.9c.1-.1.1-.2.1-.3s-.1-.1-.2-.1h-18.5c-.7,0-1.3-.5-1.5-1.1L27.4,1.2c0-.2-.1-.2-.3-.2-.1,0-.1.1-.2.2l-5.7,17.6c-.2.7-.8,1.1-1.5,1.1H1.2Z"
                    fill="none"
                    stroke="#ffffff"
                  />
                </svg>
              }
              isParentCollapsed={isLateralMenuCollapsed}
            >
              <>
                {allFavoris ? (
                  simulateurs.map((sim) => {
                    let favoris = Object.values(allFavoris);
                    if (favoris.includes(sim.id.toString())) {
                      return (
                        <li className="listElemStarHome">
                          <div className="containerItemHome">
                            <div
                              className="star"
                              onClick={(e) => {
                                ReactGA.event({
                                  category: "LateralMenu",
                                  action: "Clic etoile favoris",
                                  label: "lateralMenu_etoileFavoris",
                                });
                                onClickFavoris(sim.id);
                              }}
                            >
                              {returnStar(sim)}
                            </div>
                            <div className="barHome"></div>
                            <div
                              className="bodyText"
                              onClick={() => {
                                ReactGA.event({
                                  category: "LateralMenu",
                                  action: "Clic lien favoris",
                                  label: "lateralMenu_lienFavoris",
                                });
                                if (dmtg.includes(sim.id)) {
                                  window.location = `/categorie/${sim.subcategorie[0].categorie.url_name}/dmtg/${sim.id}`;
                                } else if (others.includes(sim.id)) {
                                  window.location = `/categorie/${sim.subcategorie[0].categorie.url_name}/others/${sim.id}`;
                                } else {
                                  window.location = `/categorie/${sim.subcategorie[0].categorie.url_name}/simulateur/${sim.id}`;
                                }
                              }}
                            >
                              {sim.shortname}
                            </div>
                          </div>
                        </li>
                      );
                    }
                    return <></>;
                  })
                ) : (
                  <></>
                )}
              </>
            </CollapseMenu>

            <CollapseMenu
              title="Pour aller plus loin"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 53 53"
                  onClick={toggleCollapse}
                >
                  <path
                    id="Icon_ionic-ios-information-circle"
                    data-name="Icon ionic-ios-information-circle"
                    d="M29.875,3.375a26.5,26.5,0,1,0,26.5,26.5A26.5,26.5,0,0,0,29.875,3.375ZM32.3,42.106H27.429V23.747H32.3ZM29.862,21.747A2.543,2.543,0,1,1,32.5,19.2,2.554,2.554,0,0,1,29.862,21.747Z"
                    transform="translate(-3.375 -3.375)"
                    fill="#ffffff"
                  />
                </svg>
              }
              isParentCollapsed={isLateralMenuCollapsed}
            >
              <ul className="lateralMenu-bullet">
                <li
                  key="Avis d/'experts"
                  className="listElemHome"
                  onClick={() => {
                    ReactGA.event({
                      category: "LateralMenu",
                      action: "Clic sur avis d'expert LateralMenu",
                      label: "lien avis d'expert LateralMenu",
                    });
                    window.location = `/avis`;
                  }}
                >
                  Avis d’experts
                  <ToolTipPerso
                    title={
                      "Focus sur des points particuliers de taxe qui suscitent des interrogations au sein des études."
                    }
                  />
                </li>
                <li
                  key="ESSENTIEL"
                  className="listElemHome"
                  onClick={() => {
                    ReactGA.event({
                      category: "LateralMenu",
                      action: "Clic sur ESSENTIEL homage",
                      label: "lien ESSENTIEL LateralMenu",
                    });
                    window.location = `/fiches`;
                  }}
                >
                  ESSENTIEL Taxe des actes - Fiches pratiques
                </li>
                <li
                  key="PRATIQUES"
                  className="listElemHome"
                  onClick={() => {
                    ReactGA.event({
                      category: "LateralMenu",
                      action: "Clic sur PRATIQUES LateralMenu",
                      label: "lien PRATIQUES LateralMenu",
                    });
                    window.location = `/pratiques`;
                  }}
                >
                  Manuels PRATIQUE sur la taxe Vol I et II
                </li>
                <li
                  key="Tableau 5"
                  className="listElemHome"
                  onClick={() => {
                    ReactGA.event({
                      category: "LateralMenu",
                      action: "Clic Tableau 5 LateralMenu",
                      label: "lien Tableau 5 LateralMenu",
                    });
                    window.location = Tableau;
                  }}
                >
                  Tableau 5 des formalités
                </li>
              </ul>
            </CollapseMenu>

            <CollapseMenu
              title="Les Éditions Langloÿs"
              icon={
                <svg
                  id="Calque_1"
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 72.48 83.69"
                  onClick={toggleCollapse}
                >
                  <path
                    d="M16,35.65c1.8,4.43,3.15,5.88,4.37,7.6l11.44,6.73c.51-3.68,1.7-5.48,3.46-7.93,0,0-9.17-.18-12.85-2.81-2.28-1.63-6.81-8.04-6.81-8.04l.38,4.44ZM17.7,47.35h-.45c-.08,0-.11.06-.06.12l.7.96c.03.05.08.06.13.06h.33c.08,0,.11-.05.07-.12l-.6-.95s-.07-.07-.12-.07M27.32,51.47v-.88c0-.63.34-1.04.97-1.04s.97.41.97,1c0,.53-.36.92-.97.92h-.97ZM27.32,52.64v-.62h.97c.93,0,1.54-.63,1.54-1.47,0-.89-.61-1.55-1.54-1.55s-1.54.67-1.54,1.59v2.05c0,.95.61,1.58,1.54,1.58s1.5-.63,1.53-1.58c0-.06-.04-.1-.1-.1h-.37c-.06,0-.1.03-.1.1-.02.62-.39,1.03-.96,1.03-.61,0-.97-.42-.97-1.03M27.1,59.34c0-.63.34-1.04.97-1.04s.97.41.97,1c0,.53-.36.92-.97.92h-.97v-.88ZM26.53,59.34v2.05c0,.95.61,1.58,1.54,1.58s1.5-.63,1.53-1.58c0-.06-.04-.1-.1-.1h-.37c-.06,0-.1.03-.1.1-.02.62-.39,1.03-.96,1.03-.61,0-.97-.42-.97-1.03v-.62h.97c.93,0,1.54-.63,1.54-1.47,0-.89-.62-1.55-1.54-1.55s-1.54.67-1.54,1.59M22.55,59.32c0-.61.36-1.03.97-1.03s.97.42.97,1.03v2.08c0,.61-.36,1.03-.97,1.03s-.97-.42-.97-1.03v-2.08ZM21.98,59.32v2.08c0,.91.61,1.58,1.54,1.58s1.54-.68,1.54-1.58v-5.48c0-.06-.04-.1-.1-.1h-.37c-.06,0-.1.04-.1.1v2.32c-.24-.3-.58-.5-.97-.5-.93,0-1.54.67-1.54,1.58M20.53,54.03c0,.06.04.1.1.1h.37c.06,0,.1-.04.1-.1v-3.46c0-.61.31-1.03.87-1.03s.87.42.87,1.03v3.46c0,.06.04.1.1.1h.37c.06,0,.1-.04.1-.1v-3.46c0-.61.31-1.03.87-1.03s.87.42.87,1.03v3.46c0,.06.04.1.1.1h.37c.06,0,.1-.04.1-.1v-3.46c0-.91-.56-1.58-1.44-1.58-.53,0-.94.31-1.15.76-.22-.44-.64-.76-1.16-.76-.88,0-1.44.67-1.44,1.58v3.46ZM19.97,57.83c-.06,0-.1.04-.1.1v4.85c0,.06.04.1.1.1h.37c.06,0,.1-.04.1-.1v-4.85c0-.06-.04-.1-.1-.1h-.37ZM19.75,56.78c0,.22.16.39.39.39s.39-.18.39-.39c0-.23-.17-.39-.39-.39s-.39.16-.39.39M17.13,51.47v-.88c0-.63.34-1.04.97-1.04s.97.41.97,1c0,.53-.36.92-.97.92h-.97ZM18.1,54.22c.89,0,1.5-.63,1.53-1.58,0-.06-.04-.1-.1-.1h-.37c-.06,0-.1.03-.1.1-.02.62-.39,1.03-.96,1.03-.61,0-.97-.42-.97-1.03v-.62h.97c.93,0,1.54-.63,1.54-1.47,0-.89-.61-1.55-1.54-1.55s-1.54.67-1.54,1.59v2.05c0,.95.61,1.58,1.54,1.58M15.74,59.32c0-.61.36-1.03.97-1.03s.97.42.97,1.03v2.08c0,.61-.36,1.03-.97,1.03s-.97-.42-.97-1.03v-2.08ZM15.16,59.32v5.48c0,.06.04.1.1.1h.37c.06,0,.1-.04.1-.1v-2.32c.24.3.57.5,1.06.5.84,0,1.45-.68,1.45-1.58v-2.08c0-.91-.62-1.58-1.55-1.58s-1.54.67-1.54,1.58M14.05,50.61v3.42c0,.06.04.1.1.1h.37c.06,0,.1-.04.1-.1v-3.42c0-.63.41-1,1.01-1h.44c.06,0,.1-.04.1-.1v-.35c0-.06-.04-.1-.1-.1h-.44c-.91,0-1.58.62-1.58,1.55M11.13,61.41c0-.49.36-.9.96-.9h.98v.9c0,.6-.35,1.01-.96,1.01s-.98-.41-.98-1.01M10.56,61.41c0,.9.61,1.56,1.55,1.56s1.53-.67,1.53-1.56v-2.11c0-.89-.6-1.56-1.52-1.56-.87,0-1.43.62-1.48,1.48,0,.06.04.1.1.1h.37c.06,0,.09-.03.1-.1.04-.56.37-.93.91-.93.6,0,.95.42.95,1.01v.66h-.98c-.92,0-1.53.65-1.53,1.45M6.47,57.53c0-.75.42-1.25,1.05-1.25s1.05.51,1.05,1.25v.75c0,.72-.43,1.22-1.06,1.22h-1.04v-1.97ZM5.86,57.53v5.25c0,.06.04.1.1.1h.4c.06,0,.1-.04.1-.1v-2.72h1.12l1.09,2.74c.02.06.06.08.11.08h.44c.07,0,.11-.05.08-.12l-1.16-2.82c.58-.24,1.02-.83,1.02-1.67v-.75c0-1.06-.68-1.82-1.65-1.82s-1.65.76-1.65,1.82M6.37,45.38c.06,0,.1-.04.1-.1v-6.86c0-.06-.04-.1-.1-.1h-.37c-.06,0-.1.04-.1.1v6.86c0,.06.04.1.1.1h.37ZM8.42,49.14c0,.71-.37,1.12-1.01,1.12h-.94v-1.61c0-.71.35-1.12.95-1.12.64,0,1,.41,1,1.12v.49ZM6.47,50.83h1.08c.66,0,1.04.42,1.04,1.13v.49c0,.71-.38,1.13-1.04,1.13h-1.08v-2.76ZM7.42,46.97c-.93,0-1.55.68-1.55,1.69v5.19c0,.18.12.3.3.3h1.38c.99,0,1.65-.68,1.65-1.7v-.49c0-.71-.39-1.27-1.01-1.46.51-.15.84-.68.84-1.35v-.49c0-1.01-.63-1.69-1.6-1.69M10.01,41.8c0,.53-.36.92-.97.92h-.97v-.88c0-.63.34-1.04.97-1.04s.97.41.97,1M10.59,41.8c0-.89-.61-1.55-1.54-1.55s-1.54.66-1.54,1.59v2.05c0,.95.61,1.58,1.54,1.58s1.5-.63,1.53-1.58c0-.06-.04-.1-.1-.1h-.37c-.06,0-.1.03-.1.1-.02.62-.39,1.03-.96,1.03-.61,0-.97-.42-.97-1.03v-.62h.97c.93,0,1.54-.63,1.54-1.47M12.46,52.66c0,.6-.35,1.01-.96,1.01s-.98-.41-.98-1.01c0-.49.36-.9.96-.9h.98v.9ZM11.51,48.98c-.87,0-1.43.62-1.48,1.48,0,.06.04.1.1.1h.37c.06,0,.09-.03.1-.1.04-.56.37-.93.91-.93.6,0,.95.42.95,1.01v.66h-.98c-.92,0-1.53.65-1.53,1.45,0,.9.61,1.56,1.55,1.56s1.53-.67,1.53-1.56v-2.11c0-.89-.59-1.56-1.52-1.56M12.16,33.35c.84,1.75,2.9,2,2.9,2l-.89-8.22s-3.54,3.02-2.01,6.22M15.36,28.01s1.99-4.8,1.99-5.69c0-1.47-2.35-4.89-2.35-4.89-.11.71-1.59,2.99-1.92,4.33-.33,1.33,2.28,6.26,2.28,6.26M23.21,28.83l-.69,2.06h-2.23l1.81,1.26-.68,2.04,1.79-1.26,1.78,1.26-.68-2.04,1.81-1.26h-2.23s-.68-2.06-.68-2.06ZM26.76,23.29l1.81-1.26h-2.23s-.68-2.06-.68-2.06l-.68,2.06h-2.23l1.81,1.26-.68,2.04,1.78-1.26,1.79,1.26-.68-2.04ZM33.88,16.75l1.81-1.26h-2.23s-.68-2.06-.68-2.06l-.68,2.06h-2.24l1.81,1.26-.68,2.04,1.78-1.26,1.79,1.26-.68-2.04ZM42.81,14.27l1.81-1.26h-2.23s-.68-2.06-.68-2.06l-.68,2.06h-2.23l1.81,1.26-.68,2.04,1.78-1.26,1.78,1.26-.68-2.04ZM45.18,27.8l1.47-5.42-3.79,3.94-1.34-4.62-1.34,4.74-3.91-4.06,1.48,5.42s-5.9-1.69-5.74-1.61l3.77,3.64-5.57.57,5.3,2.39-3.06,3.23c-.11.06,2.47-.38,4.21-.67-.01.18-.02.36-.02.55,0,3.68,2.2,6.67,4.91,6.67s4.91-2.98,4.91-6.67c0-.18,0-.35-.02-.52,1.73.29,4.16.7,4.06.64l-3.06-3.23,5.3-2.39-5.57-.57,3.77-3.64c.17-.08-5.74,1.61-5.74,1.61M51.99,16.71l1.81-1.26h-2.23s-.68-2.06-.68-2.06l-.68,2.06h-2.23l1.81,1.26-.68,2.04,1.78-1.26,1.78,1.26-.68-2.04ZM58.36,23.43l1.81-1.26h-2.23s-.68-2.06-.68-2.06l-.68,2.06h-2.23l1.81,1.26-.68,2.04,1.78-1.26,1.79,1.26-.68-2.04ZM61.9,34.45l-.68-2.04,1.81-1.26h-2.23s-.68-2.06-.68-2.06l-.68,2.06h-2.23l1.81,1.26-.68,2.04,1.78-1.26,1.78,1.26ZM60.66,43.03l-.68-2.04,1.81-1.26h-2.23s-.68-2.06-.68-2.06l-.68,2.06h-2.23l1.81,1.26-.68,2.04,1.78-1.26,1.79,1.26ZM56.12,46.69l-1.81,1.26.68,2.04-1.78-1.26-1.78,1.26.68-2.04-1.81-1.26h2.23l.68-2.06.68,2.06h2.23ZM55.01,61.78c8.27-1.07,4.11-22.34-7.12-20.42-4.46.77-7.83,7.73-11.02,7.63-3.34-.11-.32-7.25-.32-7.25,0,0-3.06,3.36-3.72,7.04-1.08,5.97,1.15,7.95,4.2,8.64,4.92,1.11,8.03-4.81,13.01-5.36,5.81-.63,4.97,9.71,4.97,9.71M54.2,61.78s.24-3.27-.66-5.96c0,0-8.88,4.02-10.36,3.24-5.15-2.69-6.63,2.72-6.63,2.72h17.65ZM35.38,68.71c1.23.04,18.83.01,18.83.01-1.07-.31-1.05-5.49-.17-5.88h-18.63c-1.94.08-1.59,5.82-.03,5.87M71.98,62.48l-35.74,20.63L.5,62.48V21.21L36.24.58l35.74,20.63v41.27ZM36.24,83.69l36.24-20.92V20.92L36.24,0,.12,20.85l-.12.07v41.85l36.24,20.92Z"
                    fill="#ffffff"
                  />
                </svg>
              }
              isParentCollapsed={isLateralMenuCollapsed}
            >
              <ul className="lateralMenu-bullet">
                <li
                  className="listElemHome"
                  onClick={() => {
                    ReactGA.event({
                      category: "LateralMenu",
                      action: "Clic sur Découvrir l'ensemble de nos produits",
                      label: "lien Découvrir l'ensemble de nos produits",
                    });
                    window.open("https://editionslangloys.com", "_blank");
                  }}
                >
                  Découvrir l'ensemble de nos produits
                </li>
                <li
                  className="listElemHome"
                  onClick={() => {
                    ReactGA.event({
                      category: "LateralMenu",
                      action: "Clic sur Commander sur la boutique en ligne",
                      label: "lien Commander sur la boutique en ligne",
                    });
                    window.open("https://editionslangloys.com/nos-produits", "_blank");
                  }}
                >
                  Commander sur la boutique en ligne
                </li>
                <li
                  className="listElemHome"
                  onClick={() => {
                    ReactGA.event({
                      category: "LateralMenu",
                      action: "Clic sur Mémo d'utilisation",
                      label: "lien Mémo d'utilisation",
                    });
                    window.open(Memo, "_blank");
                  }}
                >
                  Mémo d'utilisation
                </li>
              </ul>
            </CollapseMenu>

            <div className="collapsibleCardContact">
              <span className="collapsibleCardFlex">
                <div className="collapsibleCardIcon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="20"
                    viewBox="0 0 50.351 54.121"
                    onClick={toggleCollapse}
                  >
                    <path
                      id="Icon_awesome-calendar-check"
                      data-name="Icon awesome-calendar-check"
                      d="m5.49,0C2.46,0,0,2.46,0,5.49c0,1.73.81,3.35,2.19,4.39l24.87,18.65c1.3.97,3.09.97,4.39,0l24.87-18.65c1.38-1.04,2.19-2.66,2.19-4.39,0-3.03-2.46-5.49-5.49-5.49,0,0-47.55,0-47.55,0ZM0,12.8v23.77c0,4.03,3.28,7.32,7.32,7.32h43.89c4.03,0,7.32-3.28,7.32-7.32V12.8l-24.87,18.65c-2.61,1.95-6.17,1.95-8.78,0L0,12.8Z"
                      fill="#ffffff"
                    />
                  </svg>
                </div>
                <div className="collapsibleCardHeaderRemarque">
                  <span
                    onClick={(event) => handleChange(setOpen, true)}
                    className={`${isLateralMenuCollapsed ? "collapsed" : ""}`}
                  >
                    Vos remarques
                  </span>
                </div>
              </span>
              <div id="root"></div>
              <div id="mail-root"></div>
              <div>
                <Mail state={open} setOpen={setOpen} floatItem={true} />
              </div>
            </div>

            <CollapseMenu
              title="Espace personnel"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 56.304 54.771"
                  onClick={toggleCollapse}
                >
                  <path
                    id="Icon_material-account-circle"
                    data-name="Icon material-account-circle"
                    d="M31.152,3C15.612,3,3,15.269,3,30.385S15.612,57.771,31.152,57.771,59.3,45.5,59.3,30.385,46.692,3,31.152,3Zm0,8.216A8.322,8.322,0,0,1,39.6,19.431a8.449,8.449,0,0,1-16.891,0A8.322,8.322,0,0,1,31.152,11.216Zm0,38.887a20.423,20.423,0,0,1-16.891-8.818c.084-5.45,11.261-8.435,16.891-8.435,5.6,0,16.807,2.985,16.891,8.435A20.423,20.423,0,0,1,31.152,50.1Z"
                    transform="translate(-3 -3)"
                    fill="#ffffff"
                  />
                </svg>
              }
              isParentCollapsed={isLateralMenuCollapsed}
            >
              <ul className="lateralMenu-bullet">
                <li
                  className="listElemHome"
                  onClick={() => {
                    ReactGA.event({
                      category: "LateralMenu",
                      action: "Clic sur Découvrir l'ensemble de nos produits",
                      label: "lien Découvrir l'ensemble de nos produits",
                    });
                    window.open("/moncompte", "_blank");
                  }}
                >
                  Mon compte
                </li>
                <li
                  className="listElemHome"
                  onClick={(e) => {
                    disconnect();
                  }}
                >
                  Se déconnecter
                </li>
              </ul>
            </CollapseMenu>
          </div>
          <div className="lateralMenu-resizer" onMouseDown={() => setIsResizing(true)} />
        </div>
      </div>
    </>
  );
};

export default LateralMenu;
